import React from "react";

import './Menu.css';
import { Helmet } from "react-helmet";
import Button from "../../components/button/Button";

export const Menu: React.FC = (): JSX.Element => {

    return (
        <>
            <Helmet>
                <title>Menu - Hallwylska Restaurang</title>
                <meta name="description" content="Explore the delicious offerings on the menu at Hallwylska Restaurang. View our seasonal specials and classic dishes." />
                <link rel="canonical" href="https://hallwylskarestaurang.com/menu" />
                <meta property="og:title" content="Menu - Hallwylska Restaurang" />
                <meta property="og:description" content="Explore the delicious offerings on the menu at Hallwylska Restaurang. View our seasonal specials and classic dishes." />
                <meta property="og:image" content="https://hallwylskarestaurang.com/img/menu/julbord.png" />
                <meta property="og:url" content="https://hallwylskarestaurang.com/menu" />
                <meta name="twitter:title" content="Menu - Hallwylska Restaurang" />
                <meta name="twitter:description" content="Explore the delicious offerings on the menu at Hallwylska Restaurang. View our seasonal specials and classic dishes." />
                <meta name="twitter:image" content="https://hallwylskarestaurang.com/img/menu/julbord.png" />

            </Helmet>
            <section className="menu beige-bg pt-5 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 col-lg-8 offset-lg-2 offset-md-1 col-xl-6 offset-xl-3">
                            <h1 className="text-green text-center fly-left mb-4">Here are the menus for Summer 2025!</h1>
                            
                            <div className="text-center mb-4">
                                <img src="/img/landing.webp"
                                    alt="Three tables and spilling wine on one of them with a tree in the background"
                                    className="menu__image fly-bottom"/>
                            </div>
                            
                            <div className="menu-buttons text-center mb-5">
                                <Button text='Bar Menu'
                                    class_type="primary"
                                    onClick={() => window.open('/img/menu/HR_Bar_Menu_2025.pdf', '_blank')} />
                                <Button text='Evening Menu'
                                    class_type="primary"
                                    onClick={() => window.open('/img/menu/HR_EveningMenu_2025.pdf', '_blank')} />
                            </div>
                            
                            <div className="text-center mb-5">
                                <Button text='Make a Reservation'
                                    class_type="primary"
                                    onClick={() => window.open('https://app.bokabord.se/reservation/?hash=6e756c0ef9100e3f835612c60f140eb0')} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}